import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from './theme/ThemeProvider';
import { Layout } from './components/Layout/Layout';
import { AppRoutes } from './routes';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { store } from './store/store';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { BottomNav } from './components/Navigation/BottomNav';

function App() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider>
          <CssBaseline />
          <AuthProvider>
            <CartProvider>
              <Box sx={{ pb: isMobile ? 8 : 0 }}>
                <Layout>
                  <AppRoutes />
                </Layout>
              </Box>
              <BottomNav />
            </CartProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
